import { render } from "./orderSummary.vue?vue&type=template&id=c1044918&ts=true"
import script from "./orderSummary.vue?vue&type=script&lang=ts"
export * from "./orderSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__